import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e682165"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-12" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header flex-column flex-nowrap justify-content-around pb-2 pt-6 px-3 mx-6\" data-v-6e682165><div class=\"card-title m-0 py-3\" data-v-6e682165><h3 class=\"fw-bolder m-0\" data-v-6e682165>Car Details</h3></div><div class=\"card-subtitle row py-3\" data-v-6e682165><label class=\"col-lg-4 text-muted\" data-v-6e682165>ประเภทรายละเอียด / Labels</label><label class=\"col-lg-8 text-muted\" data-v-6e682165>Details</label></div></div>", 1)
const _hoisted_3 = { class: "px-9 pb-9" }
const _hoisted_4 = { class: "col-lg-4 fw-bold" }
const _hoisted_5 = { class: "col-lg-8 fw-bold fs-6 text-dark" }
const _hoisted_6 = {
  class: "modal fade",
  tabindex: "-1",
  id: "modal"
}
const _hoisted_7 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_8 = { class: "modal-content bg-transparent shadow-none" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "card mb-12" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header flex-column flex-nowrap justify-content-around pb-2 pt-6 px-3 mx-6\" data-v-6e682165><div class=\"card-title m-0 py-3\" data-v-6e682165><h3 class=\"fw-bolder m-0\" data-v-6e682165>Owner Details</h3></div><div class=\"card-subtitle row py-3\" data-v-6e682165><label class=\"col-lg-4 text-muted\" data-v-6e682165>ประเภทรายละเอียด / Labels</label><label class=\"col-lg-4 text-muted\" data-v-6e682165>รายละเอียด</label><label class=\"col-lg-4 text-muted\" data-v-6e682165>Details</label></div></div>", 1)
const _hoisted_12 = { class: "px-9 pb-9" }
const _hoisted_13 = { class: "col-lg-4 fw-bold" }
const _hoisted_14 = { class: "col-lg-4 fw-bold fs-6 text-dark" }
const _hoisted_15 = { class: "col-lg-4 fw-bold fs-6 text-dark" }
const _hoisted_16 = { class: "card mb-12" }
const _hoisted_17 = { class: "card-header border-0" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "card-label" }, "Store Image")
], -1))
const _hoisted_19 = { class: "card-title" }
const _hoisted_20 = {
  class: "card-label text-primary collapsible rotate",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#store-image",
  role: "button",
  "aria-expanded": "true",
  "aria-controls": "store-image"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode("See More ")
const _hoisted_22 = { class: "ms-2 rotate-90" }
const _hoisted_23 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_24 = {
  id: "store-image",
  class: "card-body collapse show"
}
const _hoisted_25 = { class: "d-flex flex-wrap" }
const _hoisted_26 = { class: "symbol symbol-100px symbol-lg-200px symbol-fixed position-relative pt-4 me-4" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "symbol symbol-200px radius-box" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-img overlay-layer" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-white" }, " image_search ")
], -1))
const _hoisted_30 = { class: "card mb-12" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "card-label" }, "Documents")
  ])
], -1))
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "symbol symbol-150px radius-box" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-img overlay-layer" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-white" }, " image_search ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CarDetailsCard = _resolveComponent("CarDetailsCard")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CarDetailsCard, {
      data: $setup.data,
      stats: $setup.stats,
      onChangeImage: $setup.changeImage,
      isCar: true
    }, null, 8, ["data", "stats", "onChangeImage"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.labels, (label, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "row py-6 border-bottom"
          }, [
            _createElementVNode("label", _hoisted_4, _toDisplayString(label.name), 1),
            _createElementVNode("span", _hoisted_5, [
              (Array.isArray($setup.data[label.key]))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(label.key2
                ? $setup.data[label.key].map((item) => item[label.key2]).join(', ') ||
                  '-'
                : $setup.data[label.key].join(', ') || '-'), 1)
                  ], 64))
                : ($setup.timeFormat.includes(label.key))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString($setup.moment($setup.data[label.key]).utc().format('ll') || '-'), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(_toDisplayString(label.key2
                ? $setup.data[label.key]?.[label.key2] || '-'
                : $setup.data[label.key] || '-'), 1)
                    ], 64))
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("img", {
            class: "figure-img img-fluid rounded m-0",
            src: 
            $setup.currentImage ||
            'https://images.squarespace-cdn.com/content/v1/5e19e28bf39c41335c1b173a/1584112794493-IAR3NEGG7WF847KLWEDT/mystery+car.jpg'
          ,
            alt: "modal image"
          }, null, 8, _hoisted_9)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.ownerLabels, (label, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "row py-6 border-bottom"
          }, [
            _createElementVNode("label", _hoisted_13, _toDisplayString(label.name), 1),
            _createElementVNode("span", _hoisted_14, _toDisplayString(!['province', 'district', 'subDistrict'].includes(label.key)
            ? $setup.data.customOwnerInfo?.[label.key] || '-'
            : $setup.data.customOwnerInfo?.[label.key].name), 1),
            _createElementVNode("span", _hoisted_15, _toDisplayString(!['province', 'district', 'subDistrict'].includes(label.key)
            ? $setup.data.customOwnerInfo?.[label.key] || '-'
            : $setup.data.customOwnerInfo?.[label.key].name), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("span", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("span", _hoisted_23, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr071.svg" })
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.imageData, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-lg-3 d-flex flex-center",
              key: `${item._id}`
            }, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", {
                  class: "overlay cursor-pointer d-flex flex-center",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#modal",
                  onClick: ($event: any) => ($setup.changeImage(item.image || _ctx.placeholderImage))
                }, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", {
                      style: _normalizeStyle(`background-image: url('${
                    item.image || _ctx.placeholderImage
                  }')`),
                      class: "custom-image-box"
                    }, null, 4),
                    _hoisted_29
                  ])
                ], 8, _hoisted_27)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _hoisted_31,
      _createElementVNode("div", {
        class: _normalizeClass([$setup.documentData.length ? 'py-0' : 'pt-0', "card-body"])
      }, [
        _createVNode(_component_Datatable, {
          "table-header": $setup.documentHeader,
          "table-data": $setup.documentData,
          enableItemsPerPageDropdown: false,
          rowsPerPage: 100
        }, {
          "cell-image": _withCtx(({ row }) => [
            _createElementVNode("div", {
              class: "overlay cursor-pointer",
              "data-bs-toggle": "modal",
              "data-bs-target": "#modal",
              onClick: ($event: any) => ($setup.changeImage(row.image))
            }, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", {
                  style: _normalizeStyle(`background-image: url('${row.image}')`),
                  class: "custom-image-box"
                }, null, 4),
                _hoisted_34
              ])
            ], 8, _hoisted_32)
          ]),
          "cell-title": _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.title), 1)
          ]),
          _: 1
        }, 8, ["table-header", "table-data"])
      ], 2)
    ])
  ], 64))
}